<!--顾问支持申请单-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button v-if="!isAdmin" icon="el-icon-plus" @click="add()">新增</el-button>
          <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-view"
            @click="view(scope.row)"
          ></el-button>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            v-if="statusEdit(scope.row.billState)"
            @click="edit(scope.row)"
          ></el-button>
          <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="220"
             v-if="scope.row.billState === 2"
          >
            <p>确定退回该顾问支持申请单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id].doClose()"
              >取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="reject(scope.row)"
              >退回</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-back"
              slot="reference"
            ></el-button>
          </el-popover> -->
          <!-- <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusUnAudit(scope.row.billState)">
            <p>确定反审核该合伙人预算单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import '@/components/EditDataTable';
import DynamicSearch from '@/components/DynamicSearch';
import DataTableMixin from '@/mixins/DataTableMixin';
import { deleteId, updatedForm,downloadExcel } from '@/api/bill/followupForm';
import { tableSataus } from '@/views/bill/mixins/status';
export default {
  name: 'FollowupForm',
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin, tableSataus],
  data() {
    return {
      tableHead: [
        {
          label: '单据编号',
          prop: 'code'
        },
        {
          label: '单据名称',
          prop: 'name',
          query: {
            type: 'input'
          }
        },
        {
          label: '客户级别',
          prop: 'shortRank'
        },
        {
          label: '申请人',
          prop: 'proposerName'
        },
        {
          label: '预计合同金额',
          prop: 'totals'
        },
        {
          label: '状态',
          prop: 'billState',
          formatter: state => {
            return this.statusName(state);
          }
        }
      ]
    };
  },
  created() {
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    // 导出
    downloadExcel() {
      downloadExcel('biz-pre-sale-application/export',this._query,'顾问支持申请单')
    },
    dataTableBeforeInit() {
      this._url = '/biz-pre-sale-application/getList';
      const params = { page: this.page, size: this.offset };
      const obj = Object.keys(this._query)[0];
      console.log(obj);
      const query = { name: this._query[obj] };
      this._params = Object.assign(params, query);
      return true;
    },
    view(row) {
      // this.$router.push({ path: `followupForm/form`, query: { id: row.id, isEdit: 0 } });
       this.$router.push({name: "followupFormForm" ,params: { id: row.id,isEdit: 0 }})
    },
    add() {
      // this.$router.push({ path: 'followupForm/form', query: { isEdit: 1 } });
       this.$router.push({name: "followupFormForm"})
    },
    edit(row) {
      // this.$router.push({ path: `followupForm/form`, query: { id: row.id, isEdit: 1, billState: row.billState } });
       this.$router.push({name: "followupFormForm" ,params: { id: row.id,isEdit: 1 }})
    },
    // 审核
    audit(data) {
      const obj = {};
      obj.bizPreSaleApplication = { id: data.id, billState: 3 };
      this.updata(obj);
      this.$refs[data.id].doClose();
    },
    // 4退回 5 反审核
    reject(data, status = 4) {
      const obj = {};
      obj.bizPreSaleApplication = { id: data.id, billState: status };
      this.updata(obj);
      this.$nextTick(() => {
        this.$refs[data.id].doClose();
      });
    },
    updata(data) {
      updatedForm(data).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '操作成功',
            type: 'success',
            duration: 2500
          });
          this.dataTableInit();
        }
      });
    },
    subDelete(id) {
      deleteId(id).then(res => {
        this.dataTableInit();
        this.$notify({
          title: '删除成功',
          type: 'success',
          duration: 2500
        });
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
